import { Link, useSearchParams } from "react-router";

import { Logo } from "../../components/icons";
import { nl } from "../../i18n/nl";
import { LAUNCH_PATH } from "../../routes/screens";
import styles from "./PrivacyPage.module.css";

const t = nl.privacy;

/** Optional contact for questions and deletion requests (`VITE_PRIVACY_CONTACT`, an e-mail address). */
function contactAddress(): string {
  return String(import.meta.env.VITE_PRIVACY_CONTACT ?? "").trim();
}

function Section({ id, title, items }: { id: string; title: string; items: readonly string[] }) {
  return (
    <section className={styles.section} aria-labelledby={id}>
      <h2 id={id} className={styles.sectionTitle}>
        {title}
      </h2>
      <ul className={styles.list}>
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </section>
  );
}

/** Public: docs/PRIVACY.md in plain language. */
export function PrivacyPage() {
  const [params] = useSearchParams();
  const contact = contactAddress();
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <Link to={LAUNCH_PATH} className={styles.brand}>
          <Logo />
          <span>{nl.app.name}</span>
        </Link>
        <Link to="/">{t.toApp}</Link>
      </header>
      <main className={styles.main} id="inhoud">
        {params.get("verwijderd") === "1" && (
          <p className={styles.notice} role="status">
            {t.deleted}
          </p>
        )}
        <h1 className={styles.title}>{nl.screens.privacy}</h1>
        <p className={styles.lead}>{t.lead}</p>
        <Section id="privacy-keep" title={t.keepTitle} items={t.keep} />
        <Section id="privacy-never" title={t.neverTitle} items={t.never} />
        <Section id="privacy-see" title={t.whoTitle} items={t.who} />
        <Section id="privacy-how" title={t.howTitle} items={t.how} />
        <Section id="privacy-keep-long" title={t.retentionTitle} items={t.retention} />
        <section className={styles.section} aria-labelledby="privacy-contact">
          <h2 id="privacy-contact" className={styles.sectionTitle}>
            {t.contactTitle}
          </h2>
          <p>
            {contact ? (
              <>
                {t.contactMail} <a href={`mailto:${contact}`}>{contact}</a>.
              </>
            ) : (
              t.contactFallback
            )}
          </p>
          <p className={styles.muted}>{t.companies}</p>
        </section>
      </main>
    </div>
  );
}
